var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMainLogoPng(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 848,
    height: 326,
    viewBox: "0 0 848 326",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.501,
    x2: 1,
    y2: 0.501,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9c5be5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d14d95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    y1: 0.475,
    x2: 0.999,
    y2: 0.475,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.086,
    y1: -4.05,
    x2: 0.086,
    y2: -3.069,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#8959c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a27ccf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -0.496,
    y1: -3.559,
    x2: 0.484,
    y2: -3.559,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#ffb1db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd86c8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.691,
    y1: 0.696,
    x2: 0.334,
    y2: 0.706,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d85099"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8048be"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -0.003,
    y1: 0.504,
    x2: 1.004,
    y2: 0.504,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.002,
    y1: 0.492,
    x2: 0.996,
    y2: 0.492,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -0.004,
    y1: 0.489,
    x2: 0.997,
    y2: 0.489,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 0.011,
    y1: 0.497,
    x2: 1.011,
    y2: 0.497,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 0.011,
    y1: 0.494,
    x2: 0.999,
    y2: 0.494,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0.006,
    y1: 0.505,
    x2: 1.002,
    y2: 0.505,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -0.001,
    y1: 0.502,
    x2: 0.983,
    y2: 0.502,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -0.006,
    y1: 0.501,
    x2: 1.001,
    y2: 0.501,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -0.004,
    y1: 0.502,
    x2: 1.009,
    y2: 0.502,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -0.016,
    y1: 0.491,
    x2: 1.002,
    y2: 0.491,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 0.005,
    y1: 0.501,
    x2: 1.004,
    y2: 0.501,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "main_logo_png",
    transform: "translate(0.479 0.365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    transform: "translate(272.06 47.669)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    transform: "translate(5.057 180.565)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    transform: "translate(9.88 4.295)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    d: "M246.561-1.6C229.092,13,211.338,27.323,193.583,41.641H0v3.723H194.729C213.056,30.473,231.383,15.582,249.711.4Z",
    transform: "translate(0 1.6)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29_1_",
    transform: "translate(266.177 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43_1_",
    d: "M306.565-3.1H89.5V.623H308.57Z",
    transform: "translate(-89.5 3.1)",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    transform: "translate(0 39.077)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    cx: 9.736,
    cy: 9.736,
    r: 9.736,
    transform: "translate(0 0)",
    fill: "#c550a6"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    d: "M244.055,106.846c0,19.473-6.3,34.077-18.614,44.387v69.873l11.168,5.441L221.719,242.3l-84.764-42.1V177.865a246.472,246.472,0,0,1,27.2-17.755,70.827,70.827,0,0,1-37.227-30.927,162.6,162.6,0,0,1-20.9-52.978L125.214,65.9a219.1,219.1,0,0,0,8.3,29.782,112.14,112.14,0,0,0,12.314,24.914,56.255,56.255,0,0,0,18.041,17.755,43.163,43.163,0,0,0,22.909,6.3c11.741,0,20.618-3.436,27.2-10.6a39.382,39.382,0,0,0,9.736-27.777,35.969,35.969,0,0,0-5.155-20.332A17.113,17.113,0,0,0,203.678,78.5,15.026,15.026,0,0,0,192.51,82.5a14.244,14.244,0,0,0-4.3,10.882,17.716,17.716,0,0,0,9.164,16.036l-14.891,12.314c-10.6-5.727-16.036-15.464-16.036-28.637a32.419,32.419,0,0,1,10.023-24.341,37.2,37.2,0,0,1,26.346-9.736c13.459,0,23.768,4.582,30.927,13.459C240.619,82.791,244.628,94.532,244.055,106.846Zm16.9-57.559H94v-18.9H260.951Zm-56.414,161.8h.859c-.859-14.318-1.432-28.35-1.432-42.1v-6.014A252.053,252.053,0,0,0,158.146,187.6Zm97.651-20.618H279.278V72.2c0-8.3-1.718-14.318-5.155-17.755s-8.591-5.155-15.464-5.155h-7.446v-18.9h12.314c8.591,0,15.177,2.864,19.473,8.591h1.145a62.721,62.721,0,0,1-4.009-16.036V17.5h22.05V30.386h28.064v18.9H302.188Zm75.028,8.877a15.719,15.719,0,0,1-4.009,10.6,14.519,14.519,0,0,1-20.618,0,13.392,13.392,0,0,1-4.009-10.6,14.451,14.451,0,0,1,4.009-10.6,15.062,15.062,0,0,1,20.618,0,14.9,14.9,0,0,1,4.009,10.6Zm-59.85,44.387a15.718,15.718,0,0,1-4.009,10.6,14.519,14.519,0,0,1-20.618,0,13.392,13.392,0,0,1-4.009-10.6,14.451,14.451,0,0,1,4.009-10.6,15.062,15.062,0,0,1,20.618,0,13.393,13.393,0,0,1,4.009,10.6Zm132.014-65L433.916,193.9l-97.651-61.569V112.573a210.127,210.127,0,0,1,34.65-26.632,173.762,173.762,0,0,1,44.959-20.9V49H320.229V30.386H466.848v18.9H438.784V171.851ZM359.174,122.31l57.846,36.941h.859a419.375,419.375,0,0,1-2.291-46.391V87.373a155.257,155.257,0,0,0-31.5,16.036A172.989,172.989,0,0,0,359.174,122.31ZM578.53,179.583l-16.9,13.173L473.148,124.6V104.555C496.63,85.369,520.685,74.2,545.312,70.764V49h-88.2V30.386h183.56v18.9H567.648V69.332q26.2.859,41.237,15.464a45.585,45.585,0,0,1,15.177,34.077A47.689,47.689,0,0,1,616.9,144.36,48.236,48.236,0,0,1,598,161.828l-14.6-16.323a33.613,33.613,0,0,0,13.745-10.6,26.876,26.876,0,0,0,5.441-16.609,24.992,24.992,0,0,0-9.164-19.759c-6.014-5.155-14.6-8.018-25.487-8.018v80.755ZM495.2,115.437l50.687,40.378h.859c-1.145-14.891-1.718-30.641-1.718-47.537V91.955A108.461,108.461,0,0,0,495.2,115.437Z",
    transform: "translate(-94 -17.5)",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    width: 848,
    height: 326,
    transform: "translate(-0.479 -0.365)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(23.852 26.363)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    width: 263,
    height: 262,
    transform: "translate(-0.331 0.272)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_49",
    "data-name": "Group 49",
    transform: "translate(19.095 18.196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-2",
    "data-name": "logo",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M112.02,7.285l19.942,114.446-19.942,97.5a58.276,58.276,0,0,1-99.711-53.179A44.693,44.693,0,0,1,26,94.61a44.671,44.671,0,0,1,35.652-68.6A30.844,30.844,0,0,1,112.02,7.285Z",
    transform: "translate(0.027 -0.004)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M150.211,165.959A58.231,58.231,0,0,1,50.5,219.138V7.285a30.844,30.844,0,0,1,50.365,18.724,44.671,44.671,0,0,1,35.453,68.513,44.693,44.693,0,0,1,13.893,71.438Z",
    transform: "translate(61.458 -0.004)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M44.231,41.476A30.778,30.778,0,0,1,31.579,16.57a31.577,31.577,0,0,1,.377-4.83,44.538,44.538,0,0,0-7.356.975,36.8,36.8,0,0,0-.2,3.856A37.979,37.979,0,0,0,39.911,47.237a3.574,3.574,0,1,0,4.232-5.761Z",
    transform: "translate(29.725 14.265)",
    fill: "#8048be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M45.479,102.892a37.957,37.957,0,0,0-3.4-8.589A44.1,44.1,0,0,0,52.908,73.238a3.3,3.3,0,0,0-6.452-1.3,37.9,37.9,0,0,1-33.785,30.02,3.279,3.279,0,0,0,.265,6.554h.285a44.206,44.206,0,0,0,23.853-9.484,30.529,30.529,0,0,1,2.035,5.6,31.221,31.221,0,0,1-3.3,23.874,3.3,3.3,0,1,0,5.678,3.338,37.836,37.836,0,0,0,4.071-28.88Z",
    transform: "translate(13.564 95.553)",
    fill: "#8048be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M45.394,65.341C32.966,63.187,18.65,52.308,12.222,40.535A34.91,34.91,0,0,0,8.864,48.6,52.321,52.321,0,0,0,44.175,72.387a3.575,3.575,0,1,0,1.219-7.046Z",
    transform: "translate(-6.89 73.648)",
    fill: "#8048be"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(148.744 26.005)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M68.472,41.476A30.755,30.755,0,0,0,81.146,16.57a31.578,31.578,0,0,0-.377-4.83,44.316,44.316,0,0,1,7.334.975,36.8,36.8,0,0,1,.2,3.855A37.979,37.979,0,0,1,72.792,47.237a3.574,3.574,0,0,1-4.232-5.761Z",
    transform: "translate(-67.102 -11.74)",
    fill: "#d85099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M79.818,134.767a3.284,3.284,0,1,0,5.655-3.324,31.174,31.174,0,0,1-3.385-23.776,30.4,30.4,0,0,1,2.027-5.574,43.964,43.964,0,0,0,23.755,9.506h.324a3.266,3.266,0,1,0,.264-6.527A37.741,37.741,0,0,1,74.791,75.236a3.284,3.284,0,0,0-6.425,1.3,44.085,44.085,0,0,0,10.763,21A38.732,38.732,0,0,0,75.764,106,37.6,37.6,0,0,0,79.818,134.767Z",
    transform: "translate(-63.588 69.14)",
    fill: "#d85099"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M77.348,65.3c12.43-2.149,26.927-12.835,33.175-24.736a54.375,54.375,0,0,1,3.324,8A52.3,52.3,0,0,1,78.567,72.349,3.575,3.575,0,1,1,77.348,65.3Z",
    transform: "translate(-40.525 47.681)",
    fill: "#d85099"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "speed_black_24dp",
    transform: "translate(44.558 47.923)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M0,0H134.827V134.827H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M100.091,37.8a5.618,5.618,0,0,0-.393,5.618,42.413,42.413,0,0,1,2.921,10.168,44.942,44.942,0,0,1-3.876,26.572,5.618,5.618,0,0,1-5,2.977H22.678a5.618,5.618,0,0,1-5-3.034A44.942,44.942,0,0,1,63.8,15.664,43.2,43.2,0,0,1,75.654,18.81,5.647,5.647,0,1,0,80.317,8.529,56.178,56.178,0,0,0,9.589,88.358a11.236,11.236,0,0,0,9.663,5.618H97.058a11.236,11.236,0,0,0,9.775-5.618,56.178,56.178,0,0,0,3.09-49.942,5.618,5.618,0,0,0-9.831-.618Z",
    transform: "translate(9.231 18.38)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M13.655,38.727a11.137,11.137,0,0,0-.921,16.348c4.39,4.39,11.2,4.623,16.819-.449L61.35,6.93Z",
    transform: "translate(45.837 32.001)",
    fill: "url(#linear-gradient-6)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_30_1_",
    transform: "translate(753.378 220.193)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4_1_",
    cx: 9.736,
    cy: 9.736,
    r: 9.736,
    transform: "translate(0)",
    fill: "url(#linear-gradient-8)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(543.283 244.116)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M194.382,99.286H189.8V94.132h4.582V86.4h5.727v7.732h6.3v5.155h-6.3v11.455a3.631,3.631,0,0,0,.286,1.718c0,.573.286.859.573,1.432a3.251,3.251,0,0,0,2.291.859h1.432c.286,0,.573-.286.859-.286l1.718,5.155a6.739,6.739,0,0,1-2.291.573,7.928,7.928,0,0,1-2.577.286,10.3,10.3,0,0,1-3.15-.573,11.6,11.6,0,0,1-2.577-1.432,8.2,8.2,0,0,1-2.291-6.014V99.286Z",
    transform: "translate(-189.8 -82.677)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M214.068,111.623h-.286a13.576,13.576,0,0,1-2.864,2.864,7.807,7.807,0,0,1-4.582,1.145,14.512,14.512,0,0,1-3.723-.573,31.251,31.251,0,0,1-3.15-1.718,10.286,10.286,0,0,1-2-2.864,7.625,7.625,0,0,1-.859-3.436,7.927,7.927,0,0,1,.859-3.723,5.053,5.053,0,0,1,2.291-2.577,6.532,6.532,0,0,1,3.436-1.718,22.108,22.108,0,0,1,4.3-.573,17.333,17.333,0,0,1,4.3.573,13.316,13.316,0,0,1,2.577.859v-.859a4.139,4.139,0,0,0-.573-2A7.6,7.6,0,0,0,212.35,95.3a4.616,4.616,0,0,0-2-1.145,6.306,6.306,0,0,0-2.291-.286,6.8,6.8,0,0,0-3.436.859,11.212,11.212,0,0,0-2.864,2.291l-4.582-3.15a11.493,11.493,0,0,1,4.582-3.723A13.282,13.282,0,0,1,207.768,89c3.723,0,6.586.859,8.877,2.864a10.776,10.776,0,0,1,3.15,8.018v14.891h-5.727Zm0-7.445a10.172,10.172,0,0,0-2.577-1.145,10.737,10.737,0,0,0-3.15-.286,6.9,6.9,0,0,0-4.3,1.145,3.593,3.593,0,0,0-1.718,3.15,3.632,3.632,0,0,0,.286,1.718,2.236,2.236,0,0,0,1.146,1.145c.573.286.859.573,1.432.859a3.633,3.633,0,0,0,1.718.286,8.36,8.36,0,0,0,2.577-.573,6.235,6.235,0,0,0,2.291-1.432,8.7,8.7,0,0,0,1.432-2A6.4,6.4,0,0,0,214.068,104.177Z",
    transform: "translate(-177.127 -77.832)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M206.786,89.473h5.441V93.2h.286c.286-.573.859-1.145,1.145-1.718a4.209,4.209,0,0,1,1.718-1.432c.573-.286,1.432-.573,2-.859a6.306,6.306,0,0,1,2.291-.286,4.246,4.246,0,0,1,2,.286,4.071,4.071,0,0,1,1.718.573L221.677,95.2a1.722,1.722,0,0,0-1.145-.286h-1.718a8.361,8.361,0,0,0-2.577.573,5.137,5.137,0,0,0-2,1.432,6.236,6.236,0,0,0-1.432,2.291,8.472,8.472,0,0,0-.573,2.864v12.886H206.5V89.473Z",
    transform: "translate(-158.677 -78.018)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M225.859,88.8a11.621,11.621,0,0,1,5.441,1.146,11.328,11.328,0,0,1,4.3,2.864,16.051,16.051,0,0,1,2.864,4.3,17.658,17.658,0,0,1,0,10.882,13.162,13.162,0,0,1-7.159,7.159,16.745,16.745,0,0,1-5.441,1.145,11.622,11.622,0,0,1-5.441-1.145,11.329,11.329,0,0,1-4.3-2.864,16.051,16.051,0,0,1-2.864-4.3,17.66,17.66,0,0,1,0-10.882,13.162,13.162,0,0,1,7.159-7.159A12.409,12.409,0,0,1,225.859,88.8Zm0,21.764a10.175,10.175,0,0,0,2.864-.573,4.453,4.453,0,0,0,2.291-1.718,9.994,9.994,0,0,0,1.718-2.577,14.372,14.372,0,0,0,.573-3.436,14.372,14.372,0,0,0-.573-3.436,4.17,4.17,0,0,0-1.718-2.577,15.879,15.879,0,0,0-2.291-1.718,7.447,7.447,0,0,0-5.727,0,4.454,4.454,0,0,0-2.291,1.718,9.994,9.994,0,0,0-1.718,2.577,14.372,14.372,0,0,0-.573,3.436,14.376,14.376,0,0,0,.573,3.436,4.17,4.17,0,0,0,1.718,2.577A15.887,15.887,0,0,0,223,109.991,12.6,12.6,0,0,0,225.859,110.564Z",
    transform: "translate(-147.681 -78.204)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M222.5,85.1h5.727v21.191h.286l9.45-9.736h7.159v.286l-9.45,9.45L245.7,121.182v.286h-6.586l-7.446-11.455-3.436,3.436v8.018H222.5Z",
    transform: "translate(-128.858 -85.1)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M235.409,103.218a3.915,3.915,0,1,1,2.864-1.145A6.047,6.047,0,0,1,235.409,103.218Z",
    transform: "translate(-112.272 -66.277)",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M238.7,99.1h-4.3V94.232h4.3V86.5h5.727v7.732h6.3V99.1h-6.3v11.168a3.631,3.631,0,0,0,.286,1.718,1.488,1.488,0,0,0,.573,1.145,3.252,3.252,0,0,0,2.291.859h1.145c.286,0,.573-.286.859-.286l1.718,4.868a5.4,5.4,0,0,1-2.291.573,7.927,7.927,0,0,1-2.577.286,10.3,10.3,0,0,1-3.15-.573,6.236,6.236,0,0,1-2.291-1.432,8.2,8.2,0,0,1-2.291-6.014Z",
    transform: "translate(-106.681 -82.491)",
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M265.441,108.846a14.818,14.818,0,0,1-4.582,4.868,11.721,11.721,0,0,1-7.159,2,13.872,13.872,0,0,1-5.155-.859A10.273,10.273,0,0,1,244.536,112a10.782,10.782,0,0,1-2.577-4.3,16.671,16.671,0,0,1-.859-5.441,16.214,16.214,0,0,1,.859-5.155,10.782,10.782,0,0,1,2.577-4.3,12.908,12.908,0,0,1,4.009-2.864A13.679,13.679,0,0,1,253.7,88.8a13.871,13.871,0,0,1,5.155.859,8.72,8.72,0,0,1,3.723,2.577,10.329,10.329,0,0,1,2.291,4.3,16.676,16.676,0,0,1,.859,5.441V103.4H246.541a5.773,5.773,0,0,0,.859,3.15,15.884,15.884,0,0,0,1.718,2.291,5.756,5.756,0,0,0,2.291,1.145,7.929,7.929,0,0,0,2.577.286A6.06,6.06,0,0,0,258,109.132a8.122,8.122,0,0,0,2.577-2.864Zm-5.155-9.736a4.069,4.069,0,0,0-.573-1.718,5.991,5.991,0,0,0-1.145-1.718,12.112,12.112,0,0,0-2-1.432,5.2,5.2,0,0,0-3.15-.573,7.034,7.034,0,0,0-4.3,1.432,6.268,6.268,0,0,0-2.291,4.009Z",
    transform: "translate(-94.194 -78.204)",
    fill: "url(#linear-gradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M275.055,108.187c-.573.859-1.146,2-1.718,2.864a6.759,6.759,0,0,1-2.577,2.291,10.585,10.585,0,0,1-3.15,1.432,16.9,16.9,0,0,1-4.009.573,13.873,13.873,0,0,1-5.155-.859,10.274,10.274,0,0,1-4.009-2.864,10.783,10.783,0,0,1-2.577-4.3,16.217,16.217,0,0,1-.859-5.155,14.978,14.978,0,0,1,.859-5.155,10.783,10.783,0,0,1,2.577-4.3,20.33,20.33,0,0,1,4.009-2.864A16.216,16.216,0,0,1,263.6,89a16.9,16.9,0,0,1,4.009.573A10.587,10.587,0,0,1,270.759,91,8.712,8.712,0,0,1,273.05,93.3a25.187,25.187,0,0,1,1.718,2.864l-5.155,2.291a5.983,5.983,0,0,0-2.291-2.864,8.277,8.277,0,0,0-4.009-1.145,12.6,12.6,0,0,0-2.864.573,4.453,4.453,0,0,0-2.291,1.718,9.993,9.993,0,0,0-1.718,2.577,6.713,6.713,0,0,0-.573,3.436,12.307,12.307,0,0,0,.573,3.436,5.15,5.15,0,0,0,1.718,2.577,15.878,15.878,0,0,0,2.291,1.718,4.71,4.71,0,0,0,2.864.573,6.574,6.574,0,0,0,4.009-1.145,7,7,0,0,0,2.577-3.15Z",
    transform: "translate(-75.744 -77.832)",
    fill: "url(#linear-gradient-17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M260.8,85.1h5.727V95.982l-.287,4.009h.287a6.207,6.207,0,0,1,3.15-2.864,8.4,8.4,0,0,1,4.582-1.145,9.563,9.563,0,0,1,4.3.859,7.31,7.31,0,0,1,2.864,2,6.826,6.826,0,0,1,1.718,3.15,17.328,17.328,0,0,1,.573,4.3v15.464h-5.727v-14.6a7.286,7.286,0,0,0-1.432-4.582,5.444,5.444,0,0,0-3.723-1.432,8.364,8.364,0,0,0-2.577.573,3.85,3.85,0,0,0-2,1.718A5.394,5.394,0,0,0,267.1,106a10.172,10.172,0,0,0-.573,2.864v12.886H260.8V85.1Z",
    transform: "translate(-57.481 -85.1)",
    fill: "url(#linear-gradient-18)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogoPng);
export default __webpack_public_path__ + "static/media/main_logo_png.d7e14ae460638dd6bb899c9d4861a8af.svg";
export { ForwardRef as ReactComponent };